"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("./about.scss");
var AboutComponent = (function () {
    function AboutComponent() {
        this.controller = AboutController;
        this.template = require("./about.html");
    }
    return AboutComponent;
}());
exports.AboutComponent = AboutComponent;
var AboutController = (function () {
    function AboutController() {
        this.socials = [
            {
                provider: "vk",
                icon: "vk",
                title: "ВКонтакте"
            },
            {
                provider: "twitter",
                icon: "twitter",
                title: "Twitter"
            },
            {
                provider: "facebook",
                icon: "facebook",
                title: "Facebook"
            },
            {
                provider: "ok",
                icon: "odnoklassniki",
                title: "Одноклассники"
            },
            {
                provider: "google",
                icon: "google-plus",
                title: "Google+"
            },
            {
                provider: "telegram",
                icon: "telegram",
                title: "Telegram"
            }
        ];
    }
    AboutController.prototype.$onInit = function () { };
    return AboutController;
}());



/** WEBPACK FOOTER **
 ** ./src/app/components/about/about.component.ts
 **/